import React from "react";
import "./AboutHeading.css";

const AboutHeading = ({
  titleStart,
  highlight,
  titleEnd,
  subtitle,
  className = "",
}) => {
  return (
    <div className={`AboutHeading-title ${className}`}>
      <h2 className="main_title">
        {titleStart} <span className="highlight">{highlight}</span>
      </h2>

      {subtitle && <p className="sub_title">{subtitle}</p>}
    </div>
  );
};

export default AboutHeading;
